export const LEAVE_CALENDAR_ROW_HEIGHT = 52;
export const LEAVE_CALENDAR_HEADER_HEIGHT = 68;
/** Default / minimum day-column width (used until viewport is measured). */
export const LEAVE_CALENDAR_CELL_WIDTH = 40;
export const LEAVE_CALENDAR_MIN_CELL_WIDTH = 36;

/** Longest span a single leave request may cover, inclusive. Must match backend LeaveTemplateResolver.MAX_LEAVE_DAYS. */
export const MAX_LEAVE_DAYS = 30;

/** Must match LeaveTemplateResolver.ALLOWED_LEAVE_TYPE_CODES (order + spelling). */
export const FIXED_LEAVE_TYPE_CODES = [
  "vacation",
  "unpaid leave",
  "additional day off",
  "additional rest time",
  "paternity leave",
  "business trip leave",
  "remote work"
] as const;

export type FixedLeaveTypeCode = (typeof FIXED_LEAVE_TYPE_CODES)[number];

/** Same as backend LeaveTemplateResolver.normalizeCode (trim + lowercase). */
export function normalizeLeaveTypeCode(raw: string): string {
  return String(raw || "")
    .trim()
    .toLowerCase();
}

/** Suffix for `leave_calendar_leave_${suffix}` i18n keys (spaces → underscores, uppercase). */
export function leaveCalendarLeaveTypeI18nSuffix(code: string): string {
  return code.replace(/ /g, "_").toUpperCase();
}

export function leaveCalendarLeaveTypeI18nKey(code: string): string {
  return `leave_calendar_leave_${leaveCalendarLeaveTypeI18nSuffix(code)}`;
}
